<template>
  <div
    class="filter-selects-equipe-profissional"
    :class="flexSize == 2 ? 'flex-2' : ''"
  >
    <vue-select
      :options="equipes"
      label="no_equipe"
      placeholder="Equipes"
      @input="handleEquipe"
    >
      <template slot="option" slot-scope="option">
        {{ option.no_equipe }}
        {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
      </template>
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
    <vue-select
      :options="profissionais"
      label="no_profissional"
      placeholder="Profissionais"
      @input="handleProfissional"
      :loading="loadingSelectProfissionais"
      :disabled="disabledSelectProfissionais"
      v-model="profissional"
    >
      <div slot="no-options">Não há opções correspondentes</div>
    </vue-select>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import utils from '@/mixins/utils.js'

export default {
  name: 'Selects',
  components: {
    VueSelect,
  },
  mixins: [utils],
  props: {
    callbackOnChangeEquipe: {
      type: [Function, Boolean],
      default: false,
    },
    activeOptionSemEquipe: {
      type: Boolean,
      default: false,
    },
    callbackOnChangeProfissional: {
      type: [Function, Boolean],
      default: false,
    },
    activeOptionTodos: {
      type: Boolean,
      default: false,
    },
    flexSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      profissional: null,
      profissionais: [],
      microarea: null,
      microareas: [],
      loadingSelectProfissionais: false,
      disabledSelectProfissionais: false,
    }
  },
  computed: {
    equipes() {
      let data = this.$store.getters['getEquipes']
      if (this.activeOptionSemEquipe) {
        data.push({
          nu_ine: 'sem-equipe',
          no_equipe: 'SEM EQUIPE',
        })
      }
      return this.removeDuplicate(data, 'nu_ine')
    },
  },
  methods: {
    async handleEquipe(val) {
      try {
        this.profissional = null
        if (val != null) {
          // carrega os profissionais ACS
          if (val.nu_ine != 'sem-equipe') {
            this.loadingSelectProfissionais = true
            this.disabledSelectProfissionais = true
            const response1 = await this.$api.get(
              '/app/profissionais/acs/' +
                this.$store.state.cod_ibge +
                '/' +
                val.nu_ine
            )
            if (response1) {
              this.profissionais = response1.data
              if (this.activeOptionTodos) {
                this.profissionais.push({
                  nu_cpf: 'todos',
                  no_profissional: 'TODOS',
                })
              }
              this.disabledSelectProfissionais = false
              this.loadingSelectProfissionais = false
            }
          } else {
            this.profissionais = []
          }
        }
        this.callbackOnChangeEquipe(val)
      } catch (error) {
        console.log(error)
      }
    },
    handleProfissional(val) {
      this.callbackOnChangeProfissional(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-selects-equipe-profissional {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin: 10px auto 30px;
  .v-select {
    flex: 0 1 33%;
    font-size: 14px;
    .vs__dropdown-toggle {
      /* background-color: #fff; */
      padding: 5px;
    }
  }
  &.flex-2 {
    .v-select {
      flex: 0 1 50%;
    }
  }
}

@media screen and (max-width: 656px) {
  .filter-selects-equipe-profissional {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
    &.flex-2 {
      .v-select {
        flex: 0 1 50%;
      }
    }
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .filter-selects-equipe-profissional {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
    &.flex-2 {
      .v-select {
        flex: 0 1 50%;
      }
    }
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .filter-selects-equipe-profissional {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    .v-select {
      width: 100%;
      margin-bottom: 10px;
    }
    &.flex-2 {
      .v-select {
        flex: 0 1 50%;
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>

<style lang="scss">
.filter-selects-equipe-profissional {
  .v-select {
    .vs__dropdown-toggle {
      height: 45px;
    }
  }
  &.flex-2 {
    .v-select {
      flex: 0 1 50%;
    }
  }
}
</style>
